import React, { useEffect, useState } from "react"
import logo from "../../asserts/boost-detailing-logo.png"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import {
  REDUX_BOOKING_SERVICES,
  REDUX_STORE_DEFAULTS,
} from "../../store/config"
import { bookingAction } from "../../store/actions/bookingAction"
import { AppointmentData } from "../../config/bookingDataConfig"
import {
  updateBookingData,
  updateData,
  updateServiceData,
} from "../../store/actions/multipleBookingAction"
import { getServiceOptions } from "../../services/api/apiModule"
import { getServices } from "../../store/actions/serviceAction"

const SelectServiceCategory = () => {
  const dispatch = useDispatch()
  const [dropDownKey, setDropDownKey] = useState()
  // const [selectService, setSelectService] = useState()
  const [selectService, setSelectService] = useState({
    categoryId: "",
    serviceId: "",
  })
  const [allServicesList, setAllServicesList] = useState([])
  const [isReadMore, setIsReadMore] = useState()
  let {
    bookingStepsLabel,
    stepNo,
    location,
    staffCategory,
    service,
    allBookingData,
    multipleBookingStatus,
    serviceCategory,
  } = useSelector((state) => state.bookingReducer)
  let { allServiceCategory } = useSelector((state) => state.serviceReducer)

  useEffect(() => {
    if (allServiceCategory) {
      setAllServicesList(allServiceCategory)
    }
    // if (Object.keys(staffCategory).length) {
    //   const staff = AppointmentData[location.id].staff.find(
    //     (staffMember) => staffMember.id === staffCategory.id
    //   )
    //   console.log(staff.servicesList,"staff.servicesList");

    //   setAllServicesList(allServiceCategory)
    // }
  }, [allServiceCategory])

  const handleCategory = (sCategProp, keyIndex) => {
    if (serviceCategory?.id === sCategProp._id) {
      dispatch(
        bookingAction(
          REDUX_STORE_DEFAULTS.UPDATE_BOOKING_SERVICE_CATEGORY(),
          {}
        )
      )
      return
    }
    // console.log(sCategProp)
    const categoryData = {
      id: sCategProp._id,
      categoryName: sCategProp.name,
      servCategoryImgUrl: sCategProp.imgUrl,
      categoryType: keyIndex,
      // description: sCategProp.description,
    }

    setSelectService((categoryId) => ({
      ...categoryId,
      categoryId: sCategProp._id,
    }))

    dispatch(
      bookingAction(
        REDUX_STORE_DEFAULTS.UPDATE_BOOKING_SERVICE_CATEGORY(),
        categoryData
      )
    )
    dispatch(
      getServices(REDUX_BOOKING_SERVICES.GET_SERVICE(), sCategProp.package)
    )
  }

  const handleService = (sCategProp, serviceProp) => {
    const serviceData = {
      id: sCategProp.id,
      categoryName: sCategProp.categoryDisplayName,
      categoryType: sCategProp.type,
      description: sCategProp.description,
      servCategoryImgUrl: sCategProp.servCategoryImgUrl,
      serviceId: serviceProp.id,
      serviceName: serviceProp.serviceDisplayName,
      serviceShortDiscription: serviceProp.serviceShortDiscription,
      servicePrice: serviceProp.price,
    }

    setSelectService((categoryId) => ({
      ...categoryId,
      categoryId: sCategProp._id,
    }))
    setSelectService((serviceId) => ({
      ...serviceId,
      serviceId: serviceProp.id,
    }))
    // setSelectService(serviceProp.id)
    //// console.log("sServices", sCategProp, serviceProp.id, selectService)
    //// console.log("s", selectService)

    if (
      serviceProp.id === selectService.serviceId &&
      sCategProp._id === selectService.categoryId
    ) {
      // console.log(true)
      dispatch(
        dispatch(
          bookingAction(REDUX_STORE_DEFAULTS.UPDATE_BOOKING_SERVICE(), {})
        )
      )
      setSelectService(
        (categoryId, serviceId) => (
          {
            ...categoryId,
            categoryId: "",
          },
          {
            ...serviceId,
            serviceId: "",
          }
        )
      )
      dispatch(updateData({}, 3))
    } else {
      dispatch(
        dispatch(
          bookingAction(
            REDUX_STORE_DEFAULTS.UPDATE_BOOKING_SERVICE(),
            serviceData
          )
        )
      )

      dispatch(updateData(serviceData, 3))

      // setTimeout(() => {
      //   dispatch(
      //     bookingAction(REDUX_STORE_DEFAULTS.UPDATE_BOOKING_STEPS(), stepNo + 1)
      //   )
      // }, 100)
    }
  }

  const TagRibbon = ({ value, allServicesList }) => {
    const tags = Array.isArray(value?.tags) ? value.tags : []

    // Color logic (kept from your code)
    const has30Here = tags.some((t) => `${t}`.includes("30%"))
    const anyHas30Anywhere = allServicesList?.some(
      (d) => Array.isArray(d?.tags) && `${d.tags[0] ?? ""}`.includes("30%")
    )
    const has20HereButNo30Anywhere =
      tags.some((t) => `${t}`.includes("20%")) && !anyHas30Anywhere

    const bgClass =
      has30Here || has20HereButNo30Anywhere ? "bg-red-500" : "bg-yellow-light"

    // Slide ticker state
    const [idx, setIdx] = React.useState(0)
    React.useEffect(() => {
      if (tags.length <= 1) return
      const id = setInterval(() => {
        setIdx((i) => (i + 1) % tags.length)
      }, 2000) // change every 2s
      return () => clearInterval(id)
    }, [tags.length])

    const itemHeight = 24 // px; should match h-6

    if (!tags.length) return null

    return (
      <div
        className={`absolute w-[10rem] text-center top-[1.5rem] -right-[3rem] text-white rotate-45 capitalize shadow-md shadow-white ${bgClass}`}
      >
        <div className="overflow-hidden h-6">
          <div
            style={{
              transform: `translateY(-${idx * itemHeight}px)`,
              transition: "transform 400ms ease",
            }}
          >
            {tags.map((t, i) => (
              <div
                key={i}
                className="h-6 flex items-center justify-center px-2"
              >
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <h1>Select Service Category</h1>
      {allServicesList.length ? (
        allServicesList.map((value, key) => {
          return (
            <>
              <div
                key={key + "serviceCat"}
                className={` border-2 mt-2 rounded flex justify-between items-center p-2 h-[9rem] cursor-pointer relative z-10 overflow-hidden ${
                  serviceCategory?.id === value._id
                    ? "bg-yellow-medium_dark bg-opacity- 35"
                    : "border-yellow-light"
                }`}
                onClick={() => {
                  handleCategory(value, key)
                }}
              >
                <div className="relative">
                  <img
                    src={value.imgUrl ? value.imgUrl : logo}
                    alt=""
                    className="md: w-[10rem] w- [7rem] h-[8rem] object-cover"
                  />
                </div>
                <div className="p -2 w-40 32 text-right pr-4 pb-3 h-full flex flex-col flex-wrap justify-end relative">
                  <h1>{value.name}</h1>
                  <p className="text-xs">
                    {_.truncate(value.description, {
                      length: 10,
                    })}
                  </p>
                </div>

                {/* {value?.tags?.length ? (
                  <div className="absolute size-[4rem] rounded-full flex justify-center items-center text-center font-bold text-white bg-yellow-light left-0 -top-5 z-10">
                    {value.tags}
                  </div>
                ) : (
                  <></>
                )} */}

                {/* {Array.isArray(value?.tags) &&
                  value.tags.map((tag, index) => (
                    <div
                      key={index}
                      className={`
                                  absolute 
                                  w-[10rem] 
                                  text-center 
                                  top-[1.5rem] 
                                  -right-[3rem] 
                                  text-white 
                                  rotate-45 
                                  capitalize 
                                  shadow-md 
                                  shadow-white
                                  ${
                                    tag.includes("30%")
                                      ? "bg-red-500"
                                      : tag.includes("20%")
                                      ? "bg-red-500"
                                      : "bg-yellow-light"
                                  }
                                `}
                      style={{
                        transform: `rotate(45deg) translateY(${index * 25}px)`, // waterfall stacking
                      }}
                    >
                      <span>{tag}</span>
                    </div>
                  ))} */}

                {value?.tags && (
                  <TagRibbon value={value} allServicesList={allServicesList} />
                )}

                {/* <div className="flex-1 flex items-center justify-end pr-6">
                    <svg
                      className={` w-6 h-6 transform duration-200 ${
                        value.id === dropDownKey ? "rotate-90" : ""
                      } `}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m8.25 4.5 7.5 7.5-7.5 7.5"
                      />
                    </svg>
                  </div> */}
              </div>
            </>
          )
        })
      ) : (
        <div className="flex justify-center flex-1">
          <span>loading....</span>
        </div>
      )}
    </>
  )
}

export default SelectServiceCategory
